import React, { PureComponent } from 'react';
import ReactTable from 'react-table';
import { Link } from 'react-router-dom';

import styled from 'styled-components';
import FilterDropdown from 'comps/filter/filter-dropdown';
import FilterDate from 'comps/filter/filter-date';
import { TableWrapper } from 'modules/list/table';

import { FORM_ACTIONS } from 'constants/form';
import {
  classMonitoringStatus,
  classStatus,
  classType,
  reviewStatus,
} from 'constants/reviews';

import { epochToDate, epochToTime } from 'utils';

const LinkNav = styled(Link)`
  text-decoration: underline;
  cursor: pointer;
  color: blue;
  text-align: center;
  &:hover {
    color: blue;
  }
  &:active {
    color: blue;
  }
`;

class TeacherClassrooms extends PureComponent {
  onFilteredChange = filters => {
    this.props.onFilter(filters);
  };

  render() {
    const { tableData } = this.props;

    const tableColumns = [
      {
        columns: [
          {
            Header: 'Teacher',
            accessor: 'teacher_name',
            width: 150,
          },
          {
            Header: 'Date',
            accessor: 'date',
            width: 180,
            filterable: true,
            Cell: ({ value }) => (value ? epochToDate(value, 'DD/MM/YYYY') : ''),
            Filter: ({ filter, onChange }) => {
              return <FilterDate filter={filter} onChange={onChange} />;
            },
          },
          {
            Header: 'Scheduled Start Time',
            accessor: 'scheduled_start_time',
            width: 150,
            Cell: ({ value }) => (value ? epochToTime(value) : ''),
          },
          {
            Header: 'Scheduled End Time',
            accessor: 'scheduled_end_time',
            width: 150,
            Cell: ({ value }) => (value ? epochToTime(value) : ''),
          },
          {
            Header: 'Enter Time',
            accessor: 'enter_time',
            width: 100,
            Cell: ({ value }) => (value ? epochToTime(value) : ''),
          },
          {
            Header: 'Exit Time',
            accessor: 'exit_time',
            width: 100,
            Cell: ({ value }) => (value ? epochToTime(value) : ''),
          },
          {
            Header: 'Class Status',
            accessor: 'status',
            filterable: true,
            width: 150,
            Filter: ({ filter, onChange }) => {
              return (
                <FilterDropdown
                  options_list={classStatus}
                  filter={filter}
                  onChange={onChange}
                  multiple={true}
                />
              );
            },
          },
          {
            // the accessor might change in future
            Header: 'Class Monitoring',
            accessor: 'should_record',
            filterable: true,
            width: 150,
            Filter: ({ filter, onChange }) => {
              return (
                <FilterDropdown
                  options_list={classMonitoringStatus}
                  filter={filter}
                  onChange={onChange}
                  multiple={false}
                />
              );
            },
          },
          {
            Header: 'Class Logs',
            accessor: '',
            width: 150,
            Cell: row => {
              return (
                <LinkNav
                  target="_blank"
                  to={{
                    pathname: `/users/teacher-classroom/${row.original.id}`,
                    state: {
                      formType: FORM_ACTIONS.VIEW,
                      student: row.original,
                    },
                  }}
                >
                  Class Logs
                </LinkNav>
              );
            },
          },
          {
            Header: 'Class Type',
            accessor: 'class_type',
            filterable: true,
            width: 150,
            Filter: ({ filter, onChange }) => {
              return (
                <FilterDropdown
                  options_list={classType}
                  filter={filter}
                  onChange={onChange}
                  multiple={true}
                />
              );
            },
          },
          /*{
            Header: 'Call Duration (mins)',
            accessor: 'call_logs_duration',
            width: 150,
            Cell: ({ value }) => (value ? parseInt(value / 60) : ''),
          },
          This column will be enabled later */
          {
            Header: 'Review Status',
            accessor: 'review_status',
            filterable: true,
            width: 150,
            Filter: ({ filter, onChange }) => {
              return (
                <FilterDropdown
                  options_list={reviewStatus}
                  filter={filter}
                  onChange={onChange}
                  multiple={true}
                />
              );
            },
          },
        ],
      },
    ];

    return (
      <React.Fragment>
        <TableWrapper>
          <ReactTable
            data={tableData}
            className="-striped -highlight"
            manual
            showPaginationTop
            showPageSizeOptions={false}
            filterable={false}
            sortable={false}
            resizable={false}
            defaultPageSize={20}
            onFilteredChange={this.onFilteredChange}
            defaultFilterMethod={(filter, row) => String(row[filter.id]) === filter.value}
            columns={tableColumns}
            style={{ textAlign: 'center' }}
          />
        </TableWrapper>
      </React.Fragment>
    );
  }
}
export default TeacherClassrooms;
